import { api, ApiError } from '../lib/api.js';
import { el } from '../lib/dom.js';
import { icon, button } from '../lib/ui.js';

export function loginView({ onSuccess }) {
  const error = el('p', { class: 'form-error', role: 'alert', hidden: true });
  const submit = button('Sign in', {
    variant: 'primary',
    type: 'submit',
    className: 'btn-block',
    title: 'Sign in to the admin portal with your ConstructMind administrator or read-only credentials.',
  });

  const email = el('input', { class: 'input', type: 'email', id: 'email', name: 'email', required: true, autocomplete: 'username', placeholder: 'admin@constructmind.ai' });
  const password = el('input', { class: 'input', type: 'password', id: 'password', name: 'password', required: true, autocomplete: 'current-password', placeholder: '••••••••••••' });

  const form = el(
    'form',
    {
      class: 'login-card',
      onsubmit: async (e) => {
        e.preventDefault();
        error.hidden = true;
        submit.disabled = true;
        submit.textContent = 'Signing in…';
        try {
          // The response carries { email, envLabel, role } only — the session
          // lives in an httpOnly cookie and is never readable from JavaScript.
          const session = await api.login(email.value, password.value);
          onSuccess(session);
        } catch (err) {
          error.textContent = err instanceof ApiError ? err.message : 'Something went wrong. Try again.';
          error.hidden = false;
          password.value = '';
          password.focus();
        } finally {
          submit.disabled = false;
          submit.textContent = 'Sign in';
        }
      },
    },
    el(
      'div',
      { class: 'login-brand' },
      el('span', { class: 'brand__mark' }, icon('logo-box')),
      el('span', {}, el('span', { class: 'brand__name', html: 'ConstructMind<em>.ai</em>' }), el('span', { class: 'brand__tag' }, 'ADMIN PORTAL')),
    ),
    el('h1', { class: 'login-title' }, 'Sign in'),
    el('p', { class: 'login-hint' }, 'Administrator or read-only access. Credentials are configured per environment.'),
    el('div', { class: 'field' }, el('label', { for: 'email' }, 'Email'), email),
    el('div', { class: 'field' }, el('label', { for: 'password' }, 'Password'), password),
    error,
    submit,
  );

  // Defer focus until the node is actually in the document.
  requestAnimationFrame(() => email.focus());

  return el('div', { class: 'login-shell' }, form);
}
